import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';

@Component({
    selector: 'scaffold-row',
    templateUrl: './row.component.html',
    styleUrls: ['../../rendered.component.scss', './row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RowComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
